<!-- eslint-disable vue/html-self-closing -->
<template>
  <div>
    <custom-select
      v-model="selectedModel"
      :options="options"
      :searchable="true"
      :clearable="true"
      :multiple="isMulti"
      :taggable="isMulti"
      :push-tags="isMulti"
      :filterable="true"
      clear-search-on-select="true"
      label="title"
      :create-option="(option) => option.replace(specialCharacters, '')"
      ref="registryCategorySelector"
    >
    </custom-select>
    <input
      :name="inputName"
      type="hidden"
      :value="makeValueForInput"
    />
  </div>
</template>

<script>
import registryService from '@shared/modules/registry/registry.service';
import PacmanLoader from '@shared/shared-components/shared/packman-loader';
// eslint-disable-next-line import/no-unresolved
import CustomSelect from './custom-select';

export default {
  name: 'GfRegistryCategorySelector',
  components: { PacmanLoader, CustomSelect },
  props: {
    alias: { default: null },
    projectAlias: { default: null },
    redirect: {
      type: Boolean,
      default: false
    },
    entityType: {
      type: String,
      default: 'INSTANCE'
    },
    selectedCategories: {
      type: String,
      default: null
    },
    isMulti: {
      type: Boolean,
      default: true
    },
    inputName: {
      type: String,
      default: 'categories'
    }
  },
  data() {
    return {
      options: [],
      selectedModel: [],
      specialCharacters: /[\${}]/g
    };
  },
  computed: {
    makeValueForInput() {
      let values = [];
      if (this.isMulti) {
        this.selectedModel?.forEach((model) => {
          if (typeof model === 'object') {
            values.push(model?.title);
          } else {
            values.push(model);
          }
        });
      } else {
        values = this.selectedModel?.title;
      }
      return values;
    }
  },
  mounted() {
    let selected = [];
    if (this.isMulti) {
      if (this.selectedCategories?.length > 0) selected = this.selectedCategories?.split(', ');
      if (selected?.length > 0) {
        selected?.forEach((category) => {
          this.selectedModel.push({ title: category });
        });
      }
    } else if (this.selectedCategories) {
      this.selectedModel = { title: this.selectedCategories };
    }
    this.getOptions();
  },
  methods: {
    getOptions() {
      switch (this.entityType) {
        case 'PROJECT': {
          this.getProjectOptions();
          break;
        }
        case 'COMPANY': {
          this.getCompanyOptions();
          break;
        }
        default: {
          this.getInstanceOptions();
          break;
        }
      }
    },
    getInstanceOptions() {
      registryService.getInstanceCategories().then((res) => {
        res?.forEach((item) => {
          this.options.push({ title: item });
        });
      });
    },
    getProjectOptions() {
      this.getInstanceOptions();
      registryService.getProjectCategories(this.alias, this.projectAlias).then((res) => {
        res?.forEach((item) => {
          this.options.push({ title: item });
        });
      });
    },
    getCompanyOptions() {
      this.getInstanceOptions();
      registryService.getCompanyCategories(this.alias).then((res) => {
        res?.forEach((item) => {
          this.options.push({ title: item });
        });
      });
    }
  }
};
</script>
